function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M13.033 3a3.296 3.296 0 013.034 3.5 3.466 3.466 0 01-2.176 3.348.234.234 0 00-.158.221v5.298a.7.7 0 01-1.4 0v-5.298c0-.1-.063-.189-.157-.221A3.468 3.468 0 0110 6.5 3.296 3.296 0 0113.033 3zM8.367 3a.7.7 0 01.7.7v2.333a3.034 3.034 0 01-2.168 2.903.234.234 0 00-.166.224v6.207a.7.7 0 01-1.4 0V9.16a.235.235 0 00-.166-.228A3.032 3.032 0 013 6.033V3.7a.7.7 0 111.4 0v2.333c0 .463.198.904.545 1.21a.23.23 0 00.25.04.235.235 0 00.138-.214V3.7a.7.7 0 011.4 0v3.37a.232.232 0 00.388.176c.348-.307.546-.749.546-1.213V3.7a.7.7 0 01.7-.7z",
  fill: "#545454",
  fillRule: "evenodd"
})));